<template>
  <div class='align-items-center'>
    <div class='d-xs-none d-flex input-group input-group-merge shadow-none m-0 flex-grow-1 justify-content-between'>
      <div v-if='showBreadCrumb' @click='showBreadCrumb = false'>
        <span class='input-group-text border-0'>
          <FeatherIcon icon='SearchIcon' />
        </span>
      </div>
      <div v-if='!showBreadCrumb' class='input-group-prepend'>
        <span class='input-group-text border-0'>
          <FeatherIcon icon='SearchIcon' />
        </span>
      </div>
      <b-form-input
        v-if='!showBreadCrumb'
        v-model='searchTerm'
        type='text'
        class='form-control files-filter border-0 bg-transparent'
        placeholder='Search'
        @keyup.enter='search(searchTerm)'
      />
      <div v-if='!showBreadCrumb' @click='closeSearch'>
        <span class='input-group-text border-0'>
          <FeatherIcon icon='XIcon' />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { BFormInput } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { messageChannelEmit } from '@core/utils/message'
import routeTypeMixin from '@/components/content/routeTypeMixin'

export default {
  components: {
    BFormInput
  },
  mixins: [routeTypeMixin],
  data: function() {
    return {
      route: '',
      showDynamicBreadcrumb: false,
      showBreadCrumb: true
    }
  },
  computed: {
    ...mapState('search', ['currentRoute', 'searchText']),
    ...mapState('appBreadcrumb', ['breadcrumbData']),
    ...mapGetters('content', ['contentTabIndex']),
    searchTerm: {
      get() {
        return this.$store.state.search.searchText
      },
      set(value) {
        this.$store.dispatch('search/setSearchText', { term: value })
      }
    },
    mobileBreadcrumbData() {
      if (this.breadcrumbData.length === 1) {
        return [this.breadcrumbData[0]]
      } else if (this.breadcrumbData.length > 1) {
        return [this.breadcrumbData[0], this.breadcrumbData[this.breadcrumbData.length - 1]]
      } else {
        return []
      }
    }
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        this.setTabIndex(0)
        this.showDynamicBreadcrumb = newVal.name === 'contents'

        if (this.showDynamicBreadcrumb && this.$store.state.appBreadcrumb.breadcrumbData.length === 0) {
          this.$store.dispatch('appBreadcrumb/refreshBreadcrumb', {
            self: this,
            organisationId: this.$route.params.organisationId,
            groupId: this.$route.params.groupId
          })
        }

        const match = this.$store.state.appBreadcrumb.breadcrumbData
          .map((x) => x.id)
          .indexOf(newVal.params.folderId !== '0' ? newVal.params.folderId : newVal.params.vaultId)
        const goToParent = match > -1 && match !== this.$store.state.appBreadcrumb.breadcrumbData.length - 1 // exists and is not the leaf node

        if (goToParent) {
          this.$store.dispatch('appBreadcrumb/goToParentBreadcrumb', {
            self: this,
            organisationId: this.$route.params.organisationId,
            groupId: this.$route.params.groupId
          })
        }
        this.showBreadCrumb = newVal.name !== 'search'
      },
      immediate: true
    }
  },
  mounted() {
    if (this.$router.currentRoute.path !== '/search') {
      this.$store.dispatch('search/setSearchText', {
        self: this,
        term: ''
      })
    }
  },
  created() {
    if (this.$router.currentRoute.path !== '/search') {
      this.$store.dispatch('search/setSearchText', {
        self: this,
        term: ''
      })
    }
  },
  methods: {
    ...mapActions('content', ['setSearchKeyWords', 'setTabIndex']),
    search() {
      messageChannelEmit(`search${this.contentTabIndex}:${this.routeType()}`)
    },
    closeSearch() {
      this.showBreadCrumb = true
      this.$store.dispatch('search/setSearchText', {
        self: this,
        term: ''
      })
      messageChannelEmit(`search${this.contentTabIndex}:${this.routeType()}`)
    }
  }
}
</script>
<style lang='scss' scoped>
@import '@/assets/scss/variables/_variables';

input {
  padding: 4px;
  height: auto;
}

.align-items-center {
  @media (max-width: 576px) {
    width: 100%;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
  }
}

.back-icon {
  color: $purple;
  padding-left: 0.2rem;
  padding-right: 0.5rem;
}
</style>
